export const CAPTURE_SYSTEM_ERROR = "CAPTURE_SYSTEM_ERROR";
export const CLEAR_SYSTEM_MESSAGE = "CLEAR_SYSTEM_MESSAGE";
export const MessageTypes = {
  WARNING: "warning",
  CRITICAL: "critical",
};

export const captureSystemWarning = ({ msg = "", data = {} } = {}) =>
  captureSystemMessage(MessageTypes.WARNING, msg, data);
export const captureSystemError = ({ msg = "", data = {} } = {}) =>
  captureSystemMessage(MessageTypes.CRITICAL, msg, data);

export const captureSystemMessage = (msgType, msg, data) => {
  return { type: CAPTURE_SYSTEM_ERROR, msgType, msg, data };
};

// Ideally, this should never be needed.
export const clearSystemMessage = () => {
  return { type: CLEAR_SYSTEM_MESSAGE };
};



// WEBPACK FOOTER //
// ./actions/systemMessageActions.js